import api from '../api';

export const getListUser = async () => {
    const result = await api.get('/admin/user');
    return result.data;
}

export const getOneUser = async (id) => {
    const result = await api.get(`/admin/user/${id}`);
    return result.data.user[0];
}

export const createUser = async (data) => {
    try {
        const response = await api.post('/admin/user', data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateUser = async (data, id) => {
    return await api.post(`/admin/user/${id}`, data);
}

export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/admin/user/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusUser = async (id) => {
    try {
        const response = await api.put(`/user/${id}/status`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusDressage = async (id) => {
    try {
        const response = await api.put(`/user/${id}/dressage`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusCso = async (id) => {
    try {
        const response = await api.put(`/user/${id}/cso`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}
